import { StyleSheet } from 'react-native'

import { PressableWithIntent } from '@zet/common/components/pressableWithIntent'
import { B4, B5, BottomSheet, Stack, XStack } from '@zet/design-system'
import { ZetUserInfo } from '@zet/feature-user/api/user/types'
import { BUTTON_TYPE } from '@zet/utils/Constants'

import { zetTopWidgets } from '../utils/constants'
import handleCardTagTop from '../utils/handleCardTagTop'

const ZetWidgetsBottomSheet = ({
  setShowHiddenIconsBottomSheet,
  showHiddenIconsBottomSheet,
  sortedWidgets,
  userSummary,
  handleCardNavigation,
}: {
  showHiddenIconsBottomSheet: boolean
  setShowHiddenIconsBottomSheet: React.Dispatch<React.SetStateAction<boolean>>
  sortedWidgets: string[]
  userSummary: ZetUserInfo | undefined
  handleCardNavigation: (route: string) => void
}) => {
  function hideBottomSheet() {
    setShowHiddenIconsBottomSheet(false)
  }

  return (
    <>
      <BottomSheet
        visible={showHiddenIconsBottomSheet}
        disableBottomSheet={hideBottomSheet}
        sheetName="menu_options"
      >
        <XStack className="mx-4 flex-wrap justify-between py-3">
          {sortedWidgets?.map((widgets, index) => (
            <Stack
              className="mb-3 w-[33%] items-center"
              key={`${widgets}-${index}`}
            >
              <PressableWithIntent
                className="w-full"
                cardTagTop={
                  userSummary[widgets]?.badge &&
                  handleCardTagTop(
                    zetTopWidgets[widgets]?.cardTagTop,
                    userSummary[widgets]?.badge
                  )
                }
                type={BUTTON_TYPE.TILE_TAG}
                name={zetTopWidgets[widgets]?.navigation}
                CardIcon={zetTopWidgets[widgets]?.cardIcon}
                cardName={zetTopWidgets[widgets]?.cardTitle}
                onPress={() =>
                  handleCardNavigation(zetTopWidgets[widgets]?.navigation)
                }
                eventName="click_action"
                eventPayload={{ item_name: zetTopWidgets[widgets]?.cardTitle }}
                style={styles.tileTag}
                customTileText={
                  <B4
                    className="text-grays-80 text-center"
                    numberOfLines={2}
                    style={styles.cardTitle}
                  >
                    {zetTopWidgets[widgets]?.cardTitle}
                  </B4>
                }
              />
              {widgets === 'referAndEarn' &&
                userSummary?.referAndEarn?.subTitle && (
                  <B5 className="bg-decorative-navel mt-2 rounded-xl px-2 py-1 text-[10px] text-white">
                    {userSummary?.referAndEarn?.subTitle}
                  </B5>
                )}
            </Stack>
          ))}
        </XStack>
      </BottomSheet>
    </>
  )
}
export default ZetWidgetsBottomSheet
const styles = StyleSheet.create({
  tileTag: {
    width: '25%',
  },
  cardTitle: {
    width: 80,
  },
})
